import Card from './CharacterCard'
import Modal from './CharacterModal'
import ModalInfo from './CharacterModalInfo'

export default {
    Card,
    Modal,
    ModalInfo
}